import { atom } from 'jotai';

const selectionErrorAtom = atom('');

export { selectionErrorAtom };